// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"6cb2e36d","600":"e5dd98dd"}[chunkId] + ".chunk.js";
};